

























import { mapGetters, mapActions, mapState } from 'vuex'
import XButton from '@/components/atoms/Button/XButton.vue'
import toastMixin from '@/mixin/toastMixin'

export default toastMixin.extend({
  mixins: [toastMixin],
  components: { XButton },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('loading', ['isLoading']),
  },
  methods: {
    ...mapActions('auth', ['resendVerification']),
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async resendEmail() {
      this.showLoading()
      await this.resendVerification().catch((error) => {
        this.hideLoading()
        throw error
      })
      this.showToast(this.$tc('verify.resendSuccess'))
      this.hideLoading()
    },
    redirect() {
      this.$router.replace(
        this.$route.params.wantedRoute || { name: 'Members' }
      )
    },
  },
})
